'use strict'

import { AppContext } from "@lightspeed-invoicing/core-client/frontend";


const Permissions = {
    AccessAllLocations: "access-all-locations",
    AdminMenus: "admin-menus",
    VoidInvoice: "void-invoice",
    DeleteInvoice: "delete-invoice",
    DeleteQuote: "delete-quote",
    QuickCreate: "quick-create",
    ManualInvoiceExport: "manual-invoice-export",
    ManualQuoteExport: "manual-quote-export",
    EditInvoiceAfterSent: "edit-invoice-after-sent",
    DeleteContact: "delete-contact",
    ShowMargin: "show-margin",
    OverwriteTotalPricePerLine: "overwrite-total-price-per-line",
    DeletePayment: "delete-payment",
    UpdateQuoteStatus: "update-quote-status",
    AccessAllUsers: "access-all-users",
    UpdateRolePermissions: "update-role-permissions",
    UpdateTax: "update-tax",
    UpdateFee: "update-fee",
    UpdateCustomField: "update-custom-field",
    UpdatePaymentTerm: "update-payment-term",
    UpdateCustomPaymentType: "update-custom-payment-type",
    UpdateCustomOrderStatus: "update-custom-order-status",
    UpdateAccount: "update-account",
    UpdateProduct: "update-product",
    BypassUpdateCreditLimit: "bypass-update-credit-limit",
    AccessQuoteMachinePayments : "access-quotemachine-payments",
    AccessInventory: "access-inventory",
}

class Guard {
    static isAuthorized(permission) {
        if (AppContext.getUserLoggedIn()) {
            if (AppContext.getUserLoggedIn().attributes.superUser) {
                return true
            }

            if (!AppContext.getUserLoggedIn().attributes.role.attributes.permissions) {
                return true
            }
            
            return AppContext.getUserLoggedIn().attributes.role.attributes.permissions[permission] === true
        }

        return false
    }
}

export default Guard
export {
    Guard, Permissions
};



// WEBPACK FOOTER //
// ./src/role/Guard.jsx